import React from "react";
import icon from "../../assets/images/PurpleLogo.svg";
import image from "../../assets/images/DASBOARDIMG.png";

const Section4 = () => {
  return (
    <section>
    <div className="tw-pt-14">
      <div className="tw-mx-7 lg:tw-mx-10 xl:tw-mx-14 2xl:tw-mx-32">
        <div className="lg:tw-ps-7 2xl:tw-ps-12">
          <div className="ProductSansBold lg:tw-border-l-2 tw-border-[#5d3393] xs:tw-ps-4 2xl:tw-ps-7 tw-relative tw-w-fit">
            <h1 className="tw-text-[22px] xl:tw-text-[27px] 2xl:tw-text-[33px] tw-text-[#062533] tw-leading-[1] max-2xl:tw-tracking-wide">
              EMPOWER YOUR BUSINESS WITH ROBUST AND POWERFUL ERP SOLUTION
            </h1>
            <h2 className="tw-text-[18px] xl:tw-text-[21px] 2xl:tw-text-[25px] ProductSansMedium xl:ProductSansRegular tw-text-[#5d3393] tw-leading-[1] tw-tracking-tight tw-mt-1 lg:tw-mt-3 2xl:tw-mt-6">
              Highly Integrated, Self Audited, Centralized Accounting
            </h2>
          </div>
        </div>
      </div>
      <div className="tw-mx-7 lg:tw-mx-10 xl:tw-mx-14 2xl:tw-mx-32">
        <img className="tw-w-full tw-mt-10 tw-px-7 2xl:tw-px-12" src={image} alt="" srcSet="" />
      </div>
    </div>
  </section>
  
  );
};

export default Section4;
